import { render, staticRenderFns } from "./UsersReports.vue?vue&type=template&id=9b037d6e"
import script from "./UsersReports.vue?vue&type=script&lang=js"
export * from "./UsersReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports